var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43384"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#C0DAFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.0521 20.4639V11.1816C25.0521 10.6082 24.5852 10.1413 24.0098 10.1413H23.7068V9.84029C23.7068 9.26693 23.2399 8.80005 22.6645 8.80005H10.0423C9.46688 8.80005 9 9.26693 9 9.84029V25.9457C9 26.519 9.46688 26.9859 10.0423 26.9859H10.3454V27.2869C10.3454 27.8603 10.8122 28.3272 11.3876 28.3272H21.2679C22.1853 30.035 23.9955 31.2001 26.076 31.2001C29.08 31.2001 31.525 28.7695 31.525 25.7798C31.525 22.4072 28.4329 19.8148 25.0521 20.4578V20.4639ZM26.076 30.5899C23.8911 30.5899 21.9375 29.1176 21.3867 26.9552C20.8461 24.8092 21.8495 22.612 23.7559 21.5717C26.9934 19.8086 30.9107 22.1697 30.9107 25.7859C30.9107 28.4357 28.7421 30.5919 26.076 30.5919V30.5899ZM20.9833 27.7169H11.3876C11.1522 27.7169 10.9597 27.5245 10.9597 27.291V11.1816C10.9597 10.9461 11.1522 10.7556 11.3876 10.7556H24.0098C24.2453 10.7556 24.4378 10.9481 24.4378 11.1816C24.4378 17.4708 24.431 20.6182 24.4173 20.6236C21.4522 21.5697 19.8693 24.8194 20.9853 27.7169H20.9833ZM9.61227 25.9477V9.84029C9.61227 9.60481 9.80476 9.41437 10.0402 9.41437H22.6624C22.8979 9.41437 23.0904 9.60685 23.0904 9.84029V10.1413H11.3876C10.8122 10.1413 10.3454 10.6082 10.3454 11.1816V26.3736H10.0423C9.8068 26.3736 9.61432 26.1811 9.61432 25.9477H9.61227Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.5937 17.7954C15.6183 17.8221 15.6469 17.8425 15.6797 17.8589C16.8858 18.7476 18.5097 18.7476 19.7158 17.8589C19.7485 17.8425 19.7772 17.82 19.8018 17.7954C22.3532 15.7887 20.9178 11.7014 17.6967 11.7014C14.4756 11.7014 13.0402 15.7887 15.5916 17.7954H15.5937ZM17.6988 12.3157C20.1007 12.3157 21.3969 15.1785 19.7792 16.9805C19.6011 16.4235 19.21 15.9668 18.7001 15.7047C19.7874 14.771 19.126 12.9853 17.6988 12.9853C16.2715 12.9853 15.6121 14.771 16.6974 15.7047C16.1896 15.9668 15.7964 16.4235 15.6183 16.9805C14.0006 15.1785 15.2947 12.3157 17.6988 12.3157ZM16.1425 17.4391C16.249 16.6631 16.9042 16.0774 17.6988 16.0774C18.4933 16.0774 19.1485 16.6631 19.255 17.4391C18.3131 18.0719 17.0824 18.0719 16.1404 17.4391H16.1425ZM16.7732 14.5314C16.7732 14.0174 17.1889 13.5997 17.7008 13.5997C18.2127 13.5997 18.6284 14.0174 18.6284 14.5314C18.6284 15.0454 18.2127 15.4631 17.7008 15.4631C17.1889 15.4631 16.7732 15.0454 16.7732 14.5314Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.2631 19.9172H23.1324C23.2942 19.9172 23.4396 19.782 23.4396 19.61C23.4396 19.4503 23.3065 19.3029 23.1324 19.3029H12.2631C11.8576 19.3029 11.8576 19.9172 12.2631 19.9172Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.9352 21.6273C21.3406 21.6273 21.3447 21.0129 20.9188 21.0129H12.2631C11.8576 21.0129 11.8576 21.6273 12.2631 21.6273H20.9352Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.8807 22.7389C19.7968 22.7123 19.8787 22.7225 12.2611 22.7225C11.8557 22.7225 11.8557 23.3368 12.2611 23.3368H19.7865C20.1326 23.3368 20.2145 22.8474 19.8807 22.7389Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.3298 24.432H12.2631C11.8576 24.432 11.8576 25.0463 12.2631 25.0463H19.3298C19.5038 25.0463 19.6369 24.903 19.6369 24.7392C19.6369 24.5753 19.5038 24.432 19.3298 24.432Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M19.3298 26.1425H12.2631C11.8597 26.1425 11.8556 26.7568 12.2631 26.7568H19.3298C19.4936 26.7568 19.6369 26.6196 19.6369 26.4496C19.6369 26.2797 19.5038 26.1425 19.3298 26.1425Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M28.2268 23.1996L26.0767 25.3497L23.9265 23.1996C23.6399 22.9129 23.2057 23.347 23.4924 23.6337L25.6425 25.7838L23.4924 27.9339C23.2057 28.2206 23.6399 28.6547 23.9265 28.368L26.0767 26.2179L28.2268 28.368C28.5134 28.6547 28.9476 28.2206 28.6609 27.9339L26.5108 25.7838L28.6609 23.6337C28.9476 23.347 28.5134 22.9129 28.2268 23.1996Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard5);
export default __webpack_public_path__ + "static/media/Card5.2360d562fd9a4e4f6b022ee6259b1e5a.svg";
export { ForwardRef as ReactComponent };